import { Url } from '../shared/Url';
import { UrlPublic } from '../shared/UrlPublic';

import Post from '../shared/Post';

import { cookieData } from '../funciones/ConsultaUser';

export const consultaImgInicio = (tipo, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            tipo: tipo
        }

        Post(`${Url}consultaImgInicio`, Content, (resp) => {
            let data = JSON.parse(resp)
            let content = [];

            data[0].map(option => {
                content.push({
                    id: option.id,
                    img: `${UrlPublic}img/home/${option.imagen}`,
                    title: option.title,
                    text: option.text
                })
            });

            respuesta(content)
        });
    });
}

export const UpdDatosInicio = (imgBanner, tipo, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            banner: imgBanner,
            tipo: tipo
        }
        console.log(Content)

        setTimeout(() => {

            Post(`${Url}UpdDatosInicio`, Content, (resp) => {
                let data = JSON.parse(resp)
                respuesta(data)
            });

        }, 200);
    });
}


// WEBPACK FOOTER //
// ./src/funciones/WebMasterFunction.jsx